module.exports = __webpack_public_path__ + "img/nokelian.97e6ba95.png";